import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { UILoader, toastError } from '@futrli/ui-components';
import { Logger, QUERY_PARAMS, getHomePageUrl } from '@futrli/shared-services';

import * as styles from './end-onboarding-flow.scss';
import { LS_FORECASTING_ONBOARDING_STEP, LS_FORECASTING_ONBOARDING_TYPE } from '../const';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';
import Button from 'carbon-react/lib/components/button';

export const EndOnboardingFlow = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId, forecastId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';
  const searchParams = new URLSearchParams(location.search);
  const workspaceIdQueryParam = searchParams.get(QUERY_PARAMS.WORKSPACE_ID);
  const organisationIdQueryParam = searchParams.get(QUERY_PARAMS.ORG_ID);

  const navigate = useNavigate();
  const { deleteForecast } = usePredictionsInfoContext();

  const handleClick = async () => {
    localStorage.removeItem(LS_FORECASTING_ONBOARDING_STEP);
    localStorage.removeItem(LS_FORECASTING_ONBOARDING_TYPE);
    const workspaceIdToUse = workspaceId || workspaceIdQueryParam || '';
    const organisationIdToUse = organisationId || organisationIdQueryParam || '';
    if (forecastId) {
      try {
        setIsLoading(true);
        await deleteForecast?.(true);
        navigate(getHomePageUrl(workspaceIdToUse, organisationIdToUse));
      } catch (e) {
        Logger.error(e as string);
        toastError();
      } finally {
        setIsLoading(false);
      }
    } else {
      navigate(getHomePageUrl(workspaceIdToUse, organisationIdToUse));
    }
  };

  if (isLoading) {
    return <UILoader isFull style={{ zIndex: 100, backgroundColor: '#f6f7fa' }} />;
  }

  return (
    <Button buttonType="primary" className={styles.endButton} onClick={handleClick}>
      <FormattedMessage id="onboarding.end_guided_flow" defaultMessage="End guided flow" />
    </Button>
  );
};
